import { FC } from 'react'

import { Button } from 'components/atoms/Button'

export interface CardListPagerProps {
  pageNumber: number
  take: number
  totalCount: number
  onPageChange: (page: number) => void
  onTakeChange: (take: number) => void
}

export const CardListPager: FC<CardListPagerProps> = ({
  pageNumber,
  take,
  totalCount,
  onPageChange,
  onTakeChange,
}: CardListPagerProps) => {
  const start = totalCount === 0 ? 0 : take * pageNumber - take + 1
  const end = take * pageNumber >= totalCount ? totalCount : take * pageNumber

  return (
    <div className='flex items-center justify-between px-3 py-[10px] border border-N-200 rounded-md mt-4'>
      <div className='flex items-center'>
        <span className='text-N-700 text-sm'>Show rows per page</span>
        <select
          className='ml-2 outline-none border border-N-200 rounded-md w-20 h-7'
          value={take}
          onChange={(e) => onTakeChange(Number(e.target.value))}>
          {[10, 20, 30, 50].map((pageSizeValue) => (
            <option key={pageSizeValue} value={pageSizeValue}>
              {pageSizeValue}
            </option>
          ))}
        </select>
      </div>

      <div className='flex items-center'>
        <div className='flex items-center text-N-700 text-sm mr-9'>
          <p>
            {start} - {end} of {totalCount}
          </p>
        </div>

        <Button
          className='mr-2'
          appearance='dull'
          size='xs'
          onClick={() => onPageChange(pageNumber - 1)}
          disabled={pageNumber <= 1}>
          <i className='ri-arrow-left-s-line' />
        </Button>

        <Button
          appearance='dull'
          size='xs'
          onClick={() => onPageChange(pageNumber + 1)}
          disabled={pageNumber * take >= totalCount}>
          <i className='ri-arrow-right-s-line' />
        </Button>
      </div>
    </div>
  )
}

export default CardListPager
